document.addEventListener('DOMContentLoaded', function () {
  var configEl = document.querySelector('[data-cart-nudge-config]');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var charmIds = {};
  config.charmIds.forEach(function (id) { charmIds[id] = true; });
  var necklaceIds = {};
  config.necklaceIds.forEach(function (id) { necklaceIds[id] = true; });

  var ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (ch) { return ESCAPE_MAP[ch]; });
  }

  function dismissKey(state) {
    return 'fac_cart_nudge_dismissed_' + state;
  }

  function isDismissed(state) {
    try {
      return window.sessionStorage.getItem(dismissKey(state)) === '1';
    } catch (e) {
      return false;
    }
  }

  function dismiss(state) {
    try {
      window.sessionStorage.setItem(dismissKey(state), '1');
    } catch (e) { /* ignore */ }
  }

  function productCardHTML(product) {
    return '<div class="cart-nudge__product">' +
      (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="" width="48" height="48" loading="lazy">' : '') +
      '<div class="cart-nudge__product-info">' +
        '<p class="cart-nudge__product-title">' + escapeHtml(product.title) + '</p>' +
        '<p class="cart-nudge__product-price">' + escapeHtml(product.price) + '</p>' +
      '</div>' +
      '<button type="button" class="cart-nudge__product-add btn btn--outline" data-quick-add data-variant-id="' + escapeHtml(product.variantId) + '">Add</button>' +
    '</div>';
  }

  function computeState(cart) {
    var charmCount = 0;
    var hasNecklace = false;
    cart.items.forEach(function (item) {
      if (charmIds[item.product_id]) charmCount += item.quantity;
      if (necklaceIds[item.product_id]) hasNecklace = true;
    });

    if (charmCount > 0 && !hasNecklace) {
      return {
        key: 'add-necklace',
        text: "This charm needs something to hang from — add a chain?",
        products: config.necklaceSuggestions
      };
    }
    if (hasNecklace && charmCount > 0 && charmCount < config.minCharms) {
      var remaining = config.minCharms - charmCount;
      var charmWord = remaining === 1 ? 'charm' : 'charms';
      return {
        key: 'add-charm-discount',
        text: 'Add ' + remaining + ' more ' + charmWord + ' to unlock ' + config.discountPercent + '% off your stack.',
        products: config.charmSuggestions
      };
    }
    return null;
  }

  function updateAllNudges(cart) {
    var state = computeState(cart);
    document.querySelectorAll('[data-cart-nudge]').forEach(function (nudge) {
      if (!state || isDismissed(state.key) || !state.products || !state.products.length) {
        nudge.hidden = true;
        return;
      }
      nudge.hidden = false;
      nudge.setAttribute('data-nudge-state', state.key);
      var textEl = nudge.querySelector('[data-cart-nudge-text]');
      var productsEl = nudge.querySelector('[data-cart-nudge-products]');
      if (textEl) textEl.textContent = state.text;
      if (productsEl) productsEl.innerHTML = state.products.map(productCardHTML).join('');
    });
  }

  document.querySelectorAll('[data-cart-nudge-dismiss]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nudge = btn.closest('[data-cart-nudge]');
      var state = nudge.getAttribute('data-nudge-state');
      if (state) dismiss(state);
      nudge.hidden = true;
    });
  });

  window.updateCartNudge = updateAllNudges;

  /* theme.js reconciles the cart against /cart.js on load and hands the result
     to updateCartNudge, so fetching it again here would just duplicate that
     request on every page view. Only fetch if the cart drawer is absent. */
  if (!window.CartDrawer) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(updateAllNudges)
      .catch(function () { /* fail quietly */ });
  }
});
